<template>
  <div
    class="line"
    :style="{ paddingLeft: node.level * 22 + 'px' }"
    @click="node.select(!node.selected)"
    :class="{ active: node.selected }"
  >
    <span class="arrow" @click="node.setOpen(!node.opened)">
      <sc-icon
        v-show="node.children.length > 0"
        :type="node.opened ? 'CaretRightOutlined' : 'CaretDownOutlined'"
      />
    </span>
    <span class="checkbox">
      <a-checkbox
        :checked="node.checked === 'yes'"
        :indeterminate="node.checked === 'half'"
        @click="node.check(node.checked !== 'yes')"
      />
    </span>
    <div class="content">
      <span class="icon"><sc-icon :type="node.data.class" /></span>
      <a-input
        class="class"
        size="small"
        :value="node.data.class"
        @update:value="$emit('data', { class: $event })"
      />
      <a-input
        class="title"
        size="small"
        :value="node.data.title"
        @update:value="$emit('data', { title: $event })"
      />
      <a-input
        class="path"
        size="small"
        style="margin-right: 10px"
        :value="node.data.path"
        @update:value="$emit('data', { path: $event })"
        v-if="node.level > 0 && node.children.length === 0"
      />
      <sc-btn
        text="add"
        size="small"
        style="margin-right: 10px"
        :handler="() => $emit('add')"
        v-if="node.level !== 2"
      />
      <sc-btn
        text="del"
        size="small"
        type="danger"
        confirm="确定"
        :handler="() => node.del()"
        style="margin-right: 10px"
      />
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from 'vue';
import {DataNode} from '@/components/common/tree/TreeUtil';
import ScBtn from '@/components/common/widget/ScBtn.vue';

export default defineComponent({
  name: 'MenuNode',
  components: { ScBtn },
  props: {
    node: {
      type: Object as PropType<DataNode<any>>,
      required: true,
    },
    menus: {
      type: Array as PropType<Array<{ title: string; handler: () => void }>>,
      default: () => [],
    },
  },
});
</script>

<style lang="scss" scoped>
.line {
  display: flex;
  flex-direction: row;
  align-items: center;

  .arrow {
    width: 16px;
    height: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: #363636;
    margin-right: 6px;
  }

  .checkbox {
    margin-right: 6px;
  }

  .title {
    flex-grow: 1;
    padding-left: 6px;
  }

  &.active {
    .title {
      //background-color: #82c3ff;
    }
  }
}

.content {
  display: flex;
  flex-direction: row;
  align-items: center;

  .icon {
    font-size: 22px;
  }

  .class {
    width: 150px;
    margin-right: 10px;
  }

  .title {
    width: 180px;
    margin-right: 10px;
  }

  .path {
    width: 220px;
  }
}
</style>
